import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { Section } from './Card';

export const Engagement = ({ isVisible }) => (
  <Section
    id="engagement"
    isVisible={isVisible}
    title={<>Engagement <span style={{ color: COLORS.cantaloupe }}>Model</span></>}
    subtitle={siteContent.engagement.subtitle}
  >
    <div className="grid md:grid-cols-3 gap-8">
      {siteContent.engagement.tiers.map((tier) => (
        <div
          key={tier.name}
          className="rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 relative"
          style={{
            backgroundColor: 'white',
            border: tier.popular ? `2px solid ${COLORS.cantaloupe}` : '1px solid #E2E8F0',
            boxShadow: tier.popular ? '0 8px 30px rgba(255,130,67,0.15)' : '0 4px 20px rgba(0,0,0,0.08)'
          }}
        >
          {tier.popular && (
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="px-4 py-1 rounded-full text-sm font-bold text-white shadow-lg" style={{ backgroundColor: COLORS.cantaloupe }}>
                MOST POPULAR
              </span>
            </div>
          )}
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-2" style={{ color: COLORS.navy }}>{tier.name}</h3>
            <div className="text-3xl font-bold mb-4" style={{ color: COLORS.cantaloupe }}>{tier.hours}</div>
            <div className="space-y-3 mb-6">
              {tier.focus.map(focus => (
                <div key={focus} className="flex items-center">
                  <span className="mr-2 text-lg" style={{ color: COLORS.teal }}>✓</span>
                  <span style={{ color: COLORS.slate }}>{focus}</span>
                </div>
              ))}
            </div>
            <div className="border-t pt-4" style={{ borderColor: '#E2E8F0' }}>
              <p className="text-sm mb-4" style={{ color: COLORS.slate }}>Key Outcome:</p>
              <p className="font-semibold" style={{ color: COLORS.navy }}>{tier.outcome}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </Section>
);
